import { apiClient } from "src/careflow/ph-core/api_client/api_client";

export const generateTemplate = async (payload: {
  rawData: string;
  templateURL: string;
  languageURL: string;
}): Promise<string> => {
  try {
    const data = await apiClient.post<any, string>(`crs/document/generate-template`, payload);
    return data;
  } catch (error) {
    return '';
  }
};